const API = "/api/servicios";

export const getServicios = async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const url = query ? `${API}?${query}` : API;
    const response = await fetch(url);
    if (!response.ok) throw new Error("Error al obtener servicios");
    return await response.json();
};

export const saveServicio = async (servicio) => {
    const response = await fetch(API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(servicio),
    });
    
    if (!response.ok) throw new Error("Error al guardar servicio");
    return await response.json();
};

export const deleteServicio = async (id, permanent = false) => {
    const url = permanent ? `${API}?id=${id}&permanent=true` : `${API}?id=${id}`;
    const response = await fetch(url, {
        method: "DELETE",
    });

    if (!response.ok) throw new Error("Error al eliminar servicio");
    return true;
};

// Aliases para compatibilidad con código existente
export const getProductos = getServicios;
export const saveProducto = saveServicio;
export const deleteProducto = deleteServicio;